import { DecorativeIcon as BaseDecorativeIcon } from "@netlify/ui";
import { type IconNameToPath } from "../SvgProvider.jsx";

export type DecorativeIconProps = {
  className?: string | undefined;
  /**
   * height sets the size of the icon's y axis.
   */
  height?: string | number | undefined;
  name: keyof typeof IconNameToPath;
  /**
   * width sets the size of the icon's x axis.
   */
  width?: string | number | undefined;
  /**
   * size sets both the size of the x and y axis using the same value.
   */
  size?: string | number | undefined;
};

/**
 * DecorativeIcon is a component that renders a purely decorative icon (it's hidden from screen
 * readers).
 */
export const DecorativeIcon = (props: DecorativeIconProps) => {
  return (
    <BaseDecorativeIcon
      height={props.size ? undefined : props.height}
      width={props.size ? props.size : props.width}
      {...props}
    />
  );
};
